export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أمس"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["دردشة"])}
}